export default "__VITE_ASSET__BeIzYJ74__"